import { FC, useState } from "react";
import { Box, Typography } from "@mui/material";
import { carModelsMenu, carsMenuHeight } from "../hardCodeData";
import LanguageAwareNavLink from "../../../components/LanguageAwareNavLink";
import { useTranslation } from "react-i18next";

interface props {
  headerHeight: string;
  openMenu: {
    language: boolean;
    carModels: boolean;
  };
}

const CarModelsMenu: FC<props> = ({ openMenu, headerHeight }) => {
  const { t } = useTranslation();
  const [categoryModels, setCategoryModels] = useState<string | null>("electric");
  const [categoryButton, setCategoryButton] = useState<string | null>("electric");
  const [slowAnimation, setSlowAnimation] = useState(false);

  const handleCategoryHover = (categoryId: string) => {
    setCategoryModels(categoryId);
  };

  const handleMenuLeave = () => {
    setTimeout(() => {
      setCategoryModels("electric");
      setCategoryButton("electric");
    }, 200);
  };

  // Фильтруем автомобили по активной категории
  const filteredCars = categoryModels
    ? carModelsMenu.filter(car => car.type === categoryModels)
    : carModelsMenu.filter(car => car.type === "electric"); // По умолчанию показываем электрические

  // Получаем уникальные категории
  const categories = Array.from(new Set(carModelsMenu.map(car => car.type)));
  return (
    <Box
      id="CarModelsMenu"
      sx={{
        display: { xs: "none", md: "flex" },
        justifyContent: { xs: "center", sm: "start" },
        height: openMenu.carModels ? carsMenuHeight : 0,
        transition: "ease-in-out 0.25s",
        width: "100%",
        background: "#fff",
        position: "fixed",
        top: headerHeight,
        overflow: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        boxShadow: "0px 0px 15px -2px #000",
        zIndex: 10,
        "&:hover": {
          height: carsMenuHeight,
        },
      }}
      onMouseLeave={handleMenuLeave}
    >
      {/* Категории */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minWidth: "200px",
          height: "100%",
          borderRight: "1px solid #e0e0e0",
          pr: 2,
          
        }}
      >
        {categories.map((category) => (
          <Box
            key={category}
            onMouseEnter={() => {
              if (categoryButton === category) return;
              setSlowAnimation(true);
              setCategoryButton(category)
              setTimeout(() => {
                setSlowAnimation(false);
              }, 200);
              setTimeout(() => handleCategoryHover(category), 150);
            }}
            sx={{
              py: 0.5,
              cursor: "pointer",
              width: "fit-content",
            }}
          >
            <Typography
              sx={{
                fontSize: "20px",
                color: categoryButton === category ? "#000" : "#555",
                textDecoration: categoryButton === category ? "underline" : "none",
                textAlign: "left",
                pl: 3,
              }}
            >
              {t(`common:${category === "electric" ? "electric_vehicles" : "hybrid"}`)}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Автомобили выбранной категории */}
      <Box
        sx={{
          transition: "ease-in-out 0.20s",
          opacity: slowAnimation ? 0 : 1,
          maxWidth: slowAnimation ? "0px" : "calc(100% - 216px)",
          overflow: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          pl: 2,
        }}
      >
        {filteredCars.map((car, i) => (
          <LanguageAwareNavLink
            style={{ textDecoration: "none", color: "inherit" }}
            key={i}
            to={`/Explore?carId=${car.id}`}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: "130px",
                width: "180px",
                transition: "ease-in-out 0.25s",
                mx: 1.5,
                my: 2.5,
                "&:hover": {
                  background: "#f9f9f9",
                  boxShadow: "5px 5px 10px 0px #d9d9d9",
                },
              }}
            >
              <Box
                sx={{
                  my: 1.5,
                  fontSize: "16px",
                  fontWeight: 500,
                  userSelect: "none",
                }}
              >
                {car.name}
              </Box>
              <img
                alt="car"
                src={car.img}
                height={"60%"}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "calc(100% - 0px)",
                  px: 1,
                  mt: 1.5,
                }}
              >
              </Box>
            </Box>
          </LanguageAwareNavLink>
        ))}
      </Box>
    </Box>
  );
};

export default CarModelsMenu;
